//  Modules from the React eco-system
import { useState, useEffect } from "react"

// Third-party modules
import { toast } from "react-toastify"

// Own components
import SubPageNavbar from "../components/navigation/subpage-navbar.component"
import Loader from "../components/loader.component"

// Navigation
import { useParams } from "react-router"
import { Switch, Route } from "react-router-dom"
import operatorDetailsRoutes from "../routes/details/operator-details.route"

// Redux
import { setPageName } from "../store/pageSlice"
import { useDispatch } from "react-redux"

// Axios
import axiosClient from "../api/api"

// Interfaces, enums
import { IOperator } from "../interfaces/persons"
import { ISubPageRoute } from "../interfaces/pages"

interface RouteParams {
    id: string
}

function OperatorDetails() {
    const dispatch = useDispatch()

    const params = useParams<RouteParams>()

    const [operator, setOperator] = useState<IOperator | null>(null)

    useEffect(() => {
        fetchRegion()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        dispatch(setPageName({ pageName: "Operators", pageUrl: "/admin/operators/main", subPageName: operator ? `${operator.firstname} ${operator.lastname}` : "" }))

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [operator])

    async function fetchRegion() {
        try {
            if (params && params.id) {
                const response = await axiosClient.get(`/operator/${params.id}`)
                const operator: IOperator = response.data
                displayWarning(operator)
                setOperator(operator)
            }
        } catch (error) {
            toast.error("Failed to fetch operator")
        }
    }

    function displayWarning(operator: IOperator) {
        !operator.image && toast.warning("This operator has not image")
        !operator.isVerified && toast.warning("This operator is not verified")
        !operator.phone && toast.warning("This operator has not phone number")
        !operator.regions && toast.warning("This operator has not region")
    }

    return (
        <div>
            {operator ? (
                <div>
                    <SubPageNavbar routes={operatorDetailsRoutes} id={operator._id} />

                    <Switch>
                        {operatorDetailsRoutes.map((route: ISubPageRoute, key: number) => {
                            return (
                                <Route
                                    key={key}
                                    path={route.path}
                                    exact
                                    render={() => {
                                        return (
                                            <div>
                                                <route.component operator={operator} setOperator={setOperator} />
                                            </div>
                                        )
                                    }}
                                />
                            )
                        })}
                    </Switch>
                </div>
            ) : (
                <Loader />
            )}
        </div>
    )
}

export default OperatorDetails
